import { createContext, useState, useEffect } from "react";
import axios from "axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false)
  const [isSuperAdmin, setIsSuperAdmin] = useState(false)
  const [isAdjudicator, setIsAdjudicator] = useState(false)
  const [loading, setLoading] = useState(true);

  const checkUser = async () => {
    if (typeof window === "undefined") {
      setIsLoggedIn(false);
      setLoading(false);
      return;
    }

    const token = localStorage.getItem("accessToken");
    if (!token) {
      setIsLoggedIn(false);
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(`${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}user/`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const admin = response.data.groups.includes(2);
      setIsAdmin(admin);

      const adjudicator = response.data.groups.includes(3);
      setIsAdjudicator(adjudicator);

      const superAdmin = response.data.groups.includes(5);
      setIsSuperAdmin(superAdmin);

      setIsLoggedIn(true);
    } catch {
      setIsLoggedIn(false);
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    checkUser();
  }, []);

  const login = (accesstoken, refreshtoken) => {
    localStorage.setItem("accessToken", accesstoken);
    localStorage.setItem("refreshToken", refreshtoken);
    checkUser()
    setIsLoggedIn(true);
  };

  const logout = () => {
    localStorage.removeItem("accessToken");
    setIsLoggedIn(false);
    setIsAdmin(false)
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn, login, logout, isAdmin, setIsAdmin, loading, isAdjudicator, isSuperAdmin, checkUser }}>
      {children}
    </AuthContext.Provider>
  );
};
